module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.accountDetails) ? _c('b-modal', {
    ref: "accountDeleteModal",
    attrs: {
      "id": "accountDeleteModal",
      "title": _vm.$t('account.modal.delete'),
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.clearAccountDeleteData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.deleteAccount($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('account.delete.confirm'))
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('account.delete.nickname'),
      "description": _vm.$t('account.delete.nickname.description'),
      "feedback": _vm.accountEditNicknameFeedback,
      "state": _vm.accountEditNicknameState
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.accountDeleteData.nickname),
      callback: function($$v) {
        _vm.accountDeleteData.nickname = $$v
      },
      expression: "accountDeleteData.nickname"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Account delete actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteAccount
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideAccountDeleteModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bb0568"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/modals/AccountDeleteModal.vue
// module id = 549
// module chunks = 0